import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectByQuestionId } from "../../services/storage/slices";
import { selectDefaultValue } from "../../services/form/slices";

function useStoredFormValue({ questionId, name: _name }) {
  const { id: formId, type: formType } = useParams();

  const { dataType, ...rest } = useSelector((state) => {
    const question = selectByQuestionId(state, {
      identifier: formId,
      type: formType,
      questionId
    });

    return question
  }, (a, b) => {
    if(!Object.keys(a)?.length && !Object.keys(b)?.length) {
      return true
    }
    return a?.dataType === b?.dataType 
      && a?.id === b?.id
      && a?.name === b?.name
  });

  const reduxValue = useSelector((state) => {
    const val = selectDefaultValue(state, {
      formId,
      formType,
      name: _name || rest?.name || rest?.dataField,
    });
    return val;
  });

  const value = reduxValue || rest?.defaultValue || "";
  return {
    ...rest,
    dataType,
    value,
  };
}
export default useStoredFormValue;
